import { ActionTree } from "vuex"
import { RootState } from "@/store/types"
import {
    MembersState,
} from "@/store/member/types"
import OfflineDB from "@/store/member/offlinedb"

const actions: ActionTree<MembersState, RootState> = {
    async populate({ commit, dispatch }) {
        await OfflineDB.populateStore(commit)
    },

    async empty({ commit }) {
        commit("empty")
        await OfflineDB.empty()
        commit("empty")
    },
}

export default actions
